import { withAuthenticationRequired } from '@auth0/auth0-react';
import React, { ComponentType } from 'react';

interface IRequireAuthProps {
    component: ComponentType<object>;
}

export const RequireAuth = (props: IRequireAuthProps) => {
    const Component = withAuthenticationRequired(props.component);

    return <Component />;
};

export default RequireAuth;
